/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './autocomplete-company.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../app/modules/custom-autocomplete/components/autocomplete-company/autocomplete-company.component';
import * as i3 from '../../../../../../$$_gendir/node_modules/primeng/components/autocomplete/autocomplete.ngfactory';
import * as i4 from 'primeng/components/dom/domhandler';
import * as i5 from 'primeng/components/utils/objectutils';
import * as i6 from 'primeng/components/autocomplete/autocomplete';
import * as i7 from '@ngx-translate/core/src/translate.pipe';
import * as i8 from '@ngx-translate/core/src/translate.service';
import * as i9 from '@angular/forms';
import * as i10 from 'primeng/components/common/shared';
import * as i11 from '../../../../../../app/modules/employee/service/company/company.service';
const styles_AutocompleteCompanyComponent:any[] = [i0.styles];
export const RenderType_AutocompleteCompanyComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AutocompleteCompanyComponent,data:{}});
function View_AutocompleteCompanyComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(0,(null as any),['\n                    ','\n                ']))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = _v.context.$implicit.name;
        _ck(_v,0,0,currVal_0);
      });
}
export function View_AutocompleteCompanyComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{textarea:0}),(_l()(),i1.ɵeld(1,0,(null as any),
      (null as any),25,'div',[['class','ui-fluid']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(3,0,(null as any),(null as any),22,'div',[['class','']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n        '])),(_l()(),i1.ɵeld(5,0,(null as any),(null as any),
          19,'div',[['class','ui-inputgroup']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i1.ɵeld(7,0,(null as any),(null as any),13,'p-autoComplete',[['delay',
          '300'],['field','name']],[[2,'ui-inputwrapper-filled',(null as any)],[2,
          'ui-inputwrapper-focus',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'completeMethod'],[(null as any),
          'change'],[(null as any),'paste'],[(null as any),'onSelect'],[(null as any),
          'ngModelChange']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.AutocompleteCompanyComponent = _v.component;
        if (('completeMethod' === en)) {
          const pd_0:any = ((<any>_co.loadCompaniesLazy($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('change' === en)) {
          const pd_1:any = ((<any>_co.change($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('paste' === en)) {
          const pd_2:any = ((<any>_co.change($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('onSelect' === en)) {
          const pd_3:any = ((<any>_co.change($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_4:any = ((<any>(_co.sel = $event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },i3.View_AutoComplete_0,i3.RenderType_AutoComplete)),i1.ɵprd(512,(null as any),
          i4.DomHandler,i4.DomHandler,([] as any[])),i1.ɵprd(512,(null as any),i5.ObjectUtils,
          i5.ObjectUtils,([] as any[])),i1.ɵdid(10,14073856,[[1,4],['input',4]],1,
          i6.AutoComplete,[i1.ElementRef,i4.DomHandler,i1.Renderer2,i5.ObjectUtils,
              i1.ChangeDetectorRef,i1.IterableDiffers],{minLength:[0,'minLength'],
              delay:[1,'delay'],placeholder:[2,'placeholder'],disabled:[3,'disabled'],
              size:[4,'size'],forceSelection:[5,'forceSelection'],field:[6,'field'],
              suggestions:[7,'suggestions']},{completeMethod:'completeMethod',onSelect:'onSelect'}),
      i1.ɵqud(603979776,2,{templates:1}),i1.ɵpid(131072,i7.TranslatePipe,[i8.TranslateService,
          i1.ChangeDetectorRef]),i1.ɵprd(1024,(null as any),i9.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.AutoComplete]),i1.ɵdid(14,671744,(null as any),0,i9.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i9.NG_VALUE_ACCESSOR]],{isDisabled:[0,
          'isDisabled'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i9.NgControl,(null as any),[i9.NgModel]),i1.ɵdid(16,16384,
          (null as any),0,i9.NgControlStatus,[i9.NgControl],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n                '])),(_l()(),i1.ɵand(0,
          (null as any),(null as any),1,(null as any),View_AutocompleteCompanyComponent_1)),
      i1.ɵdid(19,16384,[[2,4]],0,i10.PrimeTemplate,[i1.TemplateRef],{name:[0,'name']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),
          i1.ɵted(-1,(null as any),['\n            '])),(_l()(),i1.ɵeld(22,0,(null as any),
          (null as any),1,'span',[['class','ui-inputgroup-addon']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(23,0,(null as any),
          (null as any),0,'i',[['class','fa fa-refresh']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i2.AutocompleteCompanyComponent = _v.component;
    const currVal_9:any = 1;
    const currVal_10:any = '300';
    const currVal_11:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,10,2,i1.ɵnov(_v,12).transform('company')),
        '');
    const currVal_12:any = _co.disabled;
    const currVal_13:any = 30;
    const currVal_14:any = false;
    const currVal_15:any = 'name';
    const currVal_16:any = _co.companiesOptions;
    _ck(_v,10,0,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,
        currVal_16);
    const currVal_17:any = _co.disabled;
    const currVal_18:any = _co.sel;
    _ck(_v,14,0,currVal_17,currVal_18);
    const currVal_19:any = 'item';
    _ck(_v,19,0,currVal_19);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,10).filled;
    const currVal_1:any = i1.ɵnov(_v,10).focus;
    const currVal_2:any = i1.ɵnov(_v,16).ngClassUntouched;
    const currVal_3:any = i1.ɵnov(_v,16).ngClassTouched;
    const currVal_4:any = i1.ɵnov(_v,16).ngClassPristine;
    const currVal_5:any = i1.ɵnov(_v,16).ngClassDirty;
    const currVal_6:any = i1.ɵnov(_v,16).ngClassValid;
    const currVal_7:any = i1.ɵnov(_v,16).ngClassInvalid;
    const currVal_8:any = i1.ɵnov(_v,16).ngClassPending;
    _ck(_v,7,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
  });
}
export function View_AutocompleteCompanyComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-autocomplete-company',
      ([] as any[]),(null as any),(null as any),(null as any),View_AutocompleteCompanyComponent_0,
      RenderType_AutocompleteCompanyComponent)),i1.ɵprd(5120,(null as any),i9.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i2.AutocompleteCompanyComponent]),i1.ɵdid(2,638976,(null as any),0,i2.AutocompleteCompanyComponent,
      [i1.Renderer2,i11.CompanyService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const AutocompleteCompanyComponentNgFactory:i1.ComponentFactory<i2.AutocompleteCompanyComponent> = i1.ɵccf('app-autocomplete-company',
    i2.AutocompleteCompanyComponent,View_AutocompleteCompanyComponent_Host_0,{companyId:'companyId',
        companyPosition:'companyPosition',disabled:'disabled'},{onMyChange:'onMyChange'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/custom-autocomplete/components/autocomplete-company/autocomplete-company.component.ngfactory.ts